// Place laissée à la grille des élèves sur l'écran de séance du tuteur.
//
// Cet écran ne se repose pas sur le flex : il calcule à la main ce qui reste
// après le footer, les barres d'information et les encoches. Chaque élément
// ajouté en haut de l'écran doit donc être retiré de ce budget — sinon la
// barre de contrôles sort de l'écran en pleine séance. Isolé ici pour que ce
// contrat soit testable sans monter tout l'écran.

// Marge de sécurité historique de l'écran tuteur
const BREATHING_ROOM = 10

// Hauteur de la barre d'information du live (mode concentré, tuteur absent)
export const LIVE_INFORMATION_BAR_HEIGHT = 50

/**
 * @param {object} p
 * @param {number} p.windowHeight   hauteur de la fenêtre
 * @param {number} p.footerHeight   barre de contrôles du bas, encoche comprise
 * @param {number} p.insetTop       encoche haute
 * @param {boolean} p.showInformationBar  barre « mode concentré » / « tuteur absent »
 * @param {number} p.bannerHeight   bandeau web mobile (0 hors navigateur mobile)
 * @returns {number} hauteur disponible pour la grille
 */
export const availableGridHeight = ({
    windowHeight,
    footerHeight,
    insetTop = 0,
    showInformationBar = false,
    bannerHeight = 0,
}) =>
    windowHeight -
    footerHeight -
    (showInformationBar ? LIVE_INFORMATION_BAR_HEIGHT : 0) -
    bannerHeight -
    insetTop -
    BREATHING_ROOM
